import { getValidStyle, joinClasses } from 'utils/componentStyles/style.utils';
import { getDetailContent, getDetailIcon } from '../../utils/cardDetails.utils';
import './assets/weatherWidgetDetails.css';
import {
  getForecastDetailGroups,
  getGroupContainerKey,
  getResolvedForecastDetailGroups,
  getSizedDetailIcon,
} from './utils/weatherWidgetDetails.utils';

const WeatherWidgetDetails = ({
  selectedItem, // Selected item object containing all data
  details = [], // Array of detail definitions with id, label, iconKey, and getValue (uses the selectedItem data to render)
  layoutGroups = [], // Array of arrays defining the order and grouping of details to render (e.g. [['temperature', 'humidity'], ['windSpeed']])
  containerClassName, // Optional className for the container
  containerStyle, // Optional style for the container
  groupContainerClassName, // Optional className for each group container
  groupContainerStyle, // Optional style for each group container
  itemContainerClassName, // Optional className for each item
  itemContainerStyle, // Optional style for each item
  iconClassName, // Optional className for the icon
  labelClassName, // Optional className for the label
  valueClassName, // Optional className for the value
  iconSize, // Optional size for the icon
  ariaLabel = 'Forecast details',
}) => {
  if (!selectedItem || !details.length) return null;
  const forecastDetailGroups = getForecastDetailGroups(details, layoutGroups);
  const resolvedGroups = getResolvedForecastDetailGroups(details, forecastDetailGroups);
  if (!resolvedGroups.length) return null;

  return (
    <div
      aria-label={ariaLabel}
      className={joinClasses('forecast-widget-details', containerClassName)}
      role="group"
      style={getValidStyle(containerStyle)}
    >
      {resolvedGroups.map((resolvedGroup) => (
        <dl
          key={getGroupContainerKey(resolvedGroup)}
          className={joinClasses('forecast-widget-detail-group', groupContainerClassName)}
          style={getValidStyle(groupContainerStyle)}
        >
          {resolvedGroup.map((detail) => {
            const forecastDetailIcon = getSizedDetailIcon(
              getDetailIcon(detail, selectedItem),
              iconSize,
            );
            const forecastDetailContent = getDetailContent(detail, selectedItem);

            return (
              <div
                key={detail.id}
                className={joinClasses('forecast-widget-detail-item', itemContainerClassName)}
                style={getValidStyle(itemContainerStyle)}
              >
                {forecastDetailIcon && (
                  <span
                    aria-hidden="true"
                    className={joinClasses('forecast-widget-detail-icon', iconClassName)}
                  >
                    {forecastDetailIcon}
                  </span>
                )}
                <dt className={joinClasses('forecast-widget-detail-label', labelClassName)}>
                  {detail.label}
                </dt>
                <dd className={joinClasses('forecast-widget-detail-value', valueClassName)}>
                  {forecastDetailContent}
                </dd>
              </div>
            );
          })}
        </dl>
      ))}
    </div>
  );
};

export default WeatherWidgetDetails;
